

































import Vue from "vue";
import store from "@/store";
import { VSnackbar } from "vuetify/lib";
import VaButton from "../atoms/VaButton.vue";
import VaIcon from "../atoms/VaIcon.vue";

export default Vue.extend({
  components: {
    VaIcon,
    VSnackbar,
    VaButton,
  },
  computed: {
    message(): string {
      const notification = this.$store.getters["notifications/notification"];
      return notification ? notification.message : "";
    },
    type(): string | undefined {
      const notification = this.$store.getters["notifications/notification"];
      return notification ? notification.type : undefined;
    },
    computedType(): { color: string; icon: string } {
      switch (this.type) {
        case "info":
          return {
            color: "primary",
            icon: "vi vi-c-info",
          };
        case "success":
          return {
            color: "success",
            icon: "vi vi-c-check",
          };
        case "warning":
          return {
            color: "warning",
            icon: "vi vi-c-warning",
          };
        case "error":
          return {
            color: "error",
            icon: "vi vi-c-warning",
          };
        default:
          return {
            color: "",
            icon: "",
          };
      }
    },
  },
  watch: {
    message(newVal: string) {
      if (newVal !== "") {
        this.displayNotification = true;
      }
      //  else {
      //    this.displayNotification = false;
      //   // store.commit("notifications/dismissNotification");
      // }
    },
    // displayNotification(newVal: boolean) {
    //   if (!newVal) {
    //     store.commit("notifications/dismissNotification");
    //   }
    // },
  },
  data() {
    return {
      displayNotification: false,
    };
  },
  methods: {
    handleChange() {
      if (!this.displayNotification) this.dismiss();
    },
    dismiss() {
      store.commit("notifications/dismissNotification");
      // console.log(this.displayNotification);
      // console.log(this.message);
    },
  },
});
